export enum OrientationEnum {
    HORIZONTAL = 'HORIZONTAL',
    VERTICAL = 'VERTICAL',
}

